// PIPCalculator
export const PIP_CALCULATOR = 'pipCalculator';

// Constants to show calculator for wallpapers & faux tiles.
export const SUBCLASSWALLPAPER = '8';

export const toggles = {
  TWO_POINT: '2_Point',
  THREE_POINT: '3_Point'
};

export const lineItemNames = {
  PANEL: 'panel',
  BLOCK: 'block',
  SHEET: 'sheet',
  BAG: 'bag'
};

// MulchCalculator
export const MULCH_DESCRIPTION = 'Use this calculator to figure out how much product you need to complete your project';
export const MULCH_INFO = {
  classNumber: '19',
  productDepartment: '28'
};

// MulchOptions
export const mulchTypes = [
  'Wood',
  'Top Soil',
  'Rubber',
];

export const wood = [
  '1.5',
  '2'
];

export const topSoil = [
  '0.75',
  '1',
  '1.5'
];

export const rubber = [
  '0.8'
];

// useCalculator
export const MIN_AREA_NUMBER = 1;

// SAMCalculator
export const SAM_INFO = {
  classNumber: '15',
  productDepartment: '23'
};